module.exports = function() {
  return new Worker(__webpack_public_path__ + "8bb7711c1c76b9ed12bb.worker.js");
};